var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"van-haptics-feedback relative h-full w-full flex items-center justify-center border-1 rounded-4 border-dashed",style:({ borderColor: _vm.color, color: _vm.color }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('van-icon',{attrs:{"name":"plus","size":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }